import type {Result, UseCase} from 'framework';
import type {WeightTrackingError} from '../../domain/errors';
import type {WeightEntry} from '../../domain/weight-entry';
import type {WeightTrackingRepository} from '../ports/weight-tracking.repository';

export class GetLatestWeight implements UseCase<[], WeightEntry | null> {
  constructor(private readonly repository: WeightTrackingRepository) {}

  execute(): Promise<Result<WeightEntry | null, WeightTrackingError>> {
    return this.repository.getLatest();
  }
}
